// extracted by mini-css-extract-plugin
export default {"contentSection":"Home_contentSection__CztEu"};